import { RISK_CATEGORY_SELECT_OPTIONS } from '../../constants/riskCategories';

export const RISK_TYPE_OPTIONS = RISK_CATEGORY_SELECT_OPTIONS.map((option) => ({
  value: option.value,
  label: option.label,
}));